module.exports = __webpack_public_path__ + "static/media/24UHCHR12.49c02c1f.jpg";